import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import { logEvent } from 'firebase/analytics';
import $ from 'jquery';
export default {
  data: function data() {
    return {
      data01: 'All New MG5',
      data02: 'New MG Extender DC',
      data03: 'New MG Extender GC',
      data04: 'New MG EP Plus',
      data05: 'MG ZS EV MCE',
      data06: 'NEW MG VS HEV',
      data07: 'NEW MG HS'
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        console.log('12345');
        if (window.Android) {
          var devicePixelRatio = window.devicePixelRatio;
          console.log(devicePixelRatio);
          console.log(window.Android.getStatusBarHeight());
          var pxSize = Number(window.Android.getStatusBarHeight() / devicePixelRatio);
          console.log('pxsize', pxSize);
          $('.bd2').css('padding-top', pxSize);
        }
      }
    });
  },
  methods: {
    back: function back() {
      var _this = this;
      var timer = setTimeout(function () {
        _this.$router.back();
        clearTimeout(timer);
      }, 100);
    },
    toDetail: function toDetail(name) {
      // eslint-disable-next-line no-undef
      logEvent(this.$analytics, 'Club_Brochure_vehicle', {
        Brochure_vehicle_click_num: '',
        Brochure_vehicle_click_series: name,
        rochure_vehicle_click_time: ''
      });
      if (name == this.data01) {
        this.$router.push({
          path: '/social/manualsmg5'
        });
      }
      if (name == this.data02) {
        this.$router.push({
          path: '/social/manualsdc'
        });
      }
      if (name == this.data03) {
        this.$router.push({
          path: '/social/manualsgc'
        });
      }
      if (name == this.data04) {
        this.$router.push({
          path: '/social/manualsep'
        });
      }
      if (name == this.data05) {
        this.$router.push({
          path: '/social/manualsev'
        });
      }
      if (name == this.data06) {
        this.$router.push({
          path: '/social/manualsvs'
        });
      }
      if (name == this.data07) {
        this.$router.push({
          path: '/social/manualshs'
        });
      }
    }
  }
};